var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-scene"},[_c('img',{staticClass:"loading-logo",attrs:{"src":`${_vm.baseUrl}frontend-assets/img/logo-x-white.png`}}),_c('div',{staticClass:"loading-progress-bar nostripes"},[_c('span',{style:(`width: ${_vm.precent}%`)})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }